import { foundationTextFieldStyles } from '@genesislcap/foundation-ui';
import { css } from '@microsoft/fast-element';
import { PrimaryRapidColorHEX } from '../_common';
import { defaultRapidActiveBGColor, defaultRapidBGColor, defaultRapidBorderUnfocusedColor, defaultRapidTextColor, defaultRapidLabelColor, } from '../_common';
export const zeroTextFieldStyles = (context, definition) => css `
  ${foundationTextFieldStyles(context, definition)}
  :host {
    --primary-gradient-angle: -113.5deg;
  }

  :host .control {
    height: 100%;
    border-radius: calc(var(--control-corner-radius) * 1px);
  }

  :host .root {
    border: calc(var(--stroke-width) * 1px) solid ${defaultRapidBorderUnfocusedColor};
    background-color: ${defaultRapidBGColor};
  }

  :host(:hover:not([disabled])) .root {
    border-color: ${defaultRapidTextColor};
    background: none;
  }

  :host(:focus-within:not([disabled])) .root {
    background:
      linear-gradient(
          var(--primary-gradient-angle),
          ${PrimaryRapidColorHEX.blue} 0%,
          ${PrimaryRapidColorHEX.purple} 100%
        )
        top/100% 1px,
      linear-gradient(
          var(--primary-gradient-angle),
          ${PrimaryRapidColorHEX.blue} 0%,
          ${PrimaryRapidColorHEX.purple} 100%
        )
        bottom/100% 1px;
    background-color: ${defaultRapidActiveBGColor};
    background-origin: border-box;
    background-repeat: no-repeat;
    border: 1px solid transparent;
    border-right-color: ${PrimaryRapidColorHEX.blue};
    border-left-color: ${PrimaryRapidColorHEX.purple};
    box-shadow: none;
  }

  .label {
    color: ${defaultRapidLabelColor};
    margin: calc(var(--design-unit) * 2px) 0;
  }
`;
